import React ,{memo}from 'react'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';

 function SnackBarPopup(props) {
    const [open, setOpen] = React.useState(props.openSnack);

    const handleClick = () => {
      setOpen(true);
    };
  
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    };

    function SlideTransition(props) {
      return <Slide {...props} direction="up" />;
    }
  
  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}   slots={{ transition: SlideTransition }}>
        <Alert onClose={handleClose} severity="success" variant="filled" sx={{ width: '100%' }} >{props.msg}</Alert>
    </Snackbar>
  )
}
export default memo(SnackBarPopup)

